import {useQuery, useMutation, useQueryClient} from "@tanstack/react-query";
import {useAxiosPrivate} from "../useAxiosPrivate";

export default function useSmsTokenQueries() {
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient();

    // QUERIES ------------------------------------------------------

    const smsTokenGetForBusinessQuery = useQuery({
        queryKey: ["sms-token", "get_for_business"],
        queryFn: () =>
            axiosPrivate
                .get("sms-token/get_for_business/")
                .then(r => r.data)
    });

    // MUTATIONS ------------------------------------------------------

    const useBuyTokensMutation = (onSuccess) => useMutation({
        mutationFn: (data) =>
            axiosPrivate
                .post("sms-token/buy_tokens/", data)
                .then(r => r.data),
        onSuccess: (...args) => {
            queryClient.invalidateQueries(["sms-token"]);
            onSuccess && onSuccess(...args);
        }
    });

    return {
        // Queries
        smsTokenGetForBusinessQuery,

        // Mutations
        useBuyTokensMutation,
    };
}
